import { render } from "./PublicationNavigation.vue?vue&type=template&id=2fa126e0"
import script from "./PublicationNavigation.vue?vue&type=script&lang=js"
export * from "./PublicationNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__